export default {
  reports: [],
  pagination: {}
};
